var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sh-user-status-tag",class:[
    _vm.status == 'active'
      ? 'sh-user-status-tag--active'
      : 'sh-user-status-tag--inactive'
  ]},[_vm._v(" "+_vm._s(_vm.localization( `app-${_vm.status .toLowerCase() .split("_") .join("-")}`, _vm.status ))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }